export class ComProductCategoryModel  {
    // public EmployeeJobId?:CatEmployeeJobModel;
    // public ProductCategoryId?:CatProductCategoryModel;
    public commissionProductCategoryId?:number;
    public employeeJobId?:number;
    public productCategoryId?:number;
    public commission?:number;
    public paymentId?:number;

    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}